module.exports = __webpack_public_path__ + "img/icon-recharge-wiretransfer.67a9c484.svg";